import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { languages } from "../../utils/data/Languages";

export const SelectLanguage = () => {
    const handleChange = (event: SelectChangeEvent) => {
        i18next.changeLanguage(event.target.value);
    };

    const { t, i18n } = useTranslation();
    return (
        <FormControl>
            <InputLabel
                id="demo-simple-select-label"
                sx={{ color: "text.primary" }}
            >
                {t("language")}
            </InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={i18n.resolvedLanguage || i18n.language || "en"}
                label={t("language")}
                onChange={handleChange}
            >
                {languages.map(({ code, name }) => (
                    <MenuItem key={code} value={code}>
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
